import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Button } from '../ui/button';

const val = (v) => {
  if (v === null || v === undefined) return '-';
  const s = String(v).trim();
  return s ? s : '-';
};

export default function ObjectiveQuickViewModal({ open, onOpenChange, objective, onOpenNotes, onEdit }) {
  const meta = objective?.metadata || {};

  const reference = val(meta['Objective ID'] || meta['ObjectiveID'] || objective?.objective_code);
  const objectiveText = val(meta['Objective'] || objective?.objective_text);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-secondary flex items-center justify-between gap-3">
            <span>OBJECTIVE: {val(objective?.objective_code)}</span>
            <span className="text-xs text-muted-foreground">REFERENCE: {reference}</span>
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <div className="rounded-lg border overflow-hidden">
            <div className="bg-muted px-4 py-2 text-xs font-medium tracking-wider">OBJECTIVE</div>
            <div className="px-4 py-3 text-sm whitespace-pre-wrap">{objectiveText}</div>
          </div>

          <div className="rounded-lg border overflow-hidden">
            <div className="bg-muted px-4 py-2 text-xs font-medium tracking-wider">KEY OUTCOMES</div>
            <div className="px-4 py-3 text-sm whitespace-pre-wrap">{val(meta['Key Outcomes'] || meta['Key Outcome'] || meta['KeyOutcomes'])}</div>
          </div>

          <div className="rounded-lg border overflow-hidden">
            <div className="bg-muted px-4 py-2 text-xs font-medium tracking-wider">SUPPLEMENTAL INFORMATION</div>
            <div className="px-4 py-3 text-sm whitespace-pre-wrap">{val(meta['Supplemental Information'] || meta['Supplemental'] || meta['SupplementalInformation'])}</div>
          </div>

          <div className="flex justify-end gap-2">
            {onEdit && (
              <Button variant="outline" onClick={() => onEdit(objective)} data-testid="objective-quickview-edit-btn">
                Edit
              </Button>
            )}
            <Button variant="outline" onClick={onOpenNotes}>
              Notes
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
